module.exports = __webpack_public_path__ + "img/profile_avatar_mask.31aea666.svg";